module.exports = __webpack_public_path__ + "img/popup.4e640a85.png";